import { QueryHookOptions, gql } from '@apollo/client'
import { usePersistedCacheQuery } from 'app/hooks'
import { GroupVisibility } from 'app/types/GroupVisibility'

const query = gql`
  query fetchUserGroups($limit: Int!, $page: Int!) {
    userGroups(limit: $limit, page: $page) {
      totalDocs
      docs {
        id
        isOwner
        isModerator
        group {
          id
          name
          totalMembers
          visibility
          profileImage {
            id
            sizes {
              small {
                url
              }
              medium {
                url
              }
            }
          }
          university {
            slug
          }
          universityCourse {
            slug
          }
          allowedUserTypes
        }
      }
    }
  }
`

export interface UserGroupsQueryInput {
  page: number
  limit: number
}

export interface UserGroupsQueryOutput {
  userGroups: {
    totalDocs: number
    docs: {
      isOwner: boolean
      isModerator: boolean
      group: {
        id: string
        name: string
        totalMembers: number
        visibility: GroupVisibility
        profileImage: {
          id: string
          sizes: {
            small: {
              url: string
            }
            medium: {
              url: string
            }
          }
        }
        university?: {
          slug: string
        }
        universityCourse?: {
          slug: string
        }
        allowedUserTypes: string[]
      }
    }[]
  }
}

const defaultVariables: UserGroupsQueryInput = {
  page: 1,
  limit: 500,
}

export const useUserGroupsQuery = (
  options?: QueryHookOptions<UserGroupsQueryOutput, UserGroupsQueryInput>
) =>
  usePersistedCacheQuery<UserGroupsQueryOutput, UserGroupsQueryInput>(query, {
    variables: defaultVariables,
    ...options,
  })

export const userGroupsQuery = { query, defaultVariables }
